import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ChevronLeft } from 'lucide-react';

export const CookiePolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <button 
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 mb-8 text-gray-300 hover:text-white transition-colors"
        >
            <ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-widest">Back</span>
        </button>
        
        <div className="bg-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12">
            <SectionHeader subtitle="Legal" title="Cookie Policy" />

            <div className="prose prose-invert max-w-none prose-p:text-slate-300 prose-headings:text-white prose-a:text-astral-purple">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
                
                <h2>Introduction</h2>
                <p>
                    AstralVibe ("we", "our", "us") uses cookies on our website (astralvibe.art). By using the website, you consent to the use of cookies.
                    Our Cookie Policy explains what cookies are, how we use them, how third-parties we may partner with may use cookies on the website, your choices regarding cookies, and further information about cookies.
                </p>
                
                <h2>What are cookies</h2>
                <p>
                    Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored in your web browser and allows the website or a third-party to recognize you and make your next visit easier and the website more useful to you. Cookies can be "persistent" or "session" cookies.
                </p>

                <h2>How AstralVibe uses cookies</h2>
                <p>
                    When you use and access the website, we may place a number of cookie files in your web browser. We use cookies for the following purposes:
                </p>
                <ul>
                    <li>To enable certain functions of the website.</li>
                    <li>To provide analytics.</li>
                    <li>To store your preferences.</li>
                </ul>
                <p>
                    We use both session and persistent cookies on the website, and we use different types of cookies to run the website. We may use essential cookies to authenticate users and prevent fraudulent use of user accounts.
                </p>

                <h2>Third-party cookies</h2>
                <p>
                    In addition to our own cookies, we may also use various third-parties cookies to report usage statistics of the website, deliver advertisements on and through the website, and so on.
                </p>

                <h2>What are your choices regarding cookies</h2>
                <p>
                    If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser. Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.
                </p>

                <h2>Contact us</h2>
                <p>
                    If you have any questions about this Cookie Policy, you can contact us by visiting the <Link to="/contact" className="text-astral-purple hover:underline">Contact</Link> section of our site.
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};